import React, { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import ResiLayout from 'layout/ResiLayout';
import GuestGuard from 'utils/route-guard/GuestGuard';

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));

// render - login
const GuestLogOut = Loadable(lazy(() => import('pages/guest/GuestLogOut')));

// ==============================|| AUTH ROUTING ||============================== //

const GuestRoutes = {
    path: '/',
    children: [
        {
            path: '*',
            element: <MaintenanceError />
        },
        {
            path: '/',
            element: (
                <GuestGuard>
                    <ResiLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: '/',
                    element: <GuestLogOut />
                },
                {
                    path: 'guest-not-allowed',
                    element: <GuestLogOut />
                }
            ]
        }
    ]
};

export default GuestRoutes;
